export default __webpack_public_path__ + "static/16951_JFK_Facility_Spec_A07-5-a82136898135915abffa9761ddbee644.jpg";